Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const vscode = require("vscode-languageserver-protocol");
const featureWorkers_1 = require("../utils/featureWorkers");
const common_1 = require("../utils/common");
function register(context) {
    return (uri, position) => {
        return (0, featureWorkers_1.languageFeatureWorker)(context, uri, position, (position, map) => map.toGeneratedPositions(position, data => !!data.hover), (plugin, document, position) => { var _a; return (_a = plugin.doHover) === null || _a === void 0 ? void 0 : _a.call(plugin, document, position); }, (item, map) => {
            if (!map || !item.range)
                return item;
            const range = map.toSourceRange(item.range);
            if (range) {
                item.range = range;
                return item;
            }
        }, hovers => {
            var _a, _b;
            return ({
                contents: hovers.map(getHoverTexts).flat(),
                range: (_b = (_a = hovers.find(hover => hover.range && (0, common_1.isInsideRange)(hover.range, { start: position, end: position }))) === null || _a === void 0 ? void 0 : _a.range) !== null && _b !== void 0 ? _b : hovers[0].range,
            });
        });
    };
}
exports.register = register;
function getHoverTexts(hover) {
    if (!hover) {
        return [];
    }
    if (typeof hover.contents === 'string') {
        return [hover.contents];
    }
    if (vscode.MarkupContent.is(hover.contents)) {
        return [hover.contents.value];
    }
    if (Array.isArray(hover.contents)) {
        return hover.contents;
    }
    return [hover.contents.value];
}
//# sourceMappingURL=hover.js.map